import { en } from './en';

export type TranslationKeys = typeof en;

export const hi: TranslationKeys = {
  // Navigation
  nav: {
    home: 'होम',
    profile: 'प्रोफ़ाइल',
    schemes: 'योजनाएं',
    applications: 'आवेदन',
    fraudCheck: 'धोखाधड़ी जांच',
    learnFinance: 'वित्त सीखें',
    appTitle: 'ग्रामीण डिजिटल अधिकार',
  },

  // Home Page
  home: {
    welcome: 'ग्रामीण डिजिटल अधिकार में आपका स्वागत है',
    subtitle: 'आपके लिए तैयार सरकारी योजनाओं की खोज करें',
    getStarted: 'शुरू करें',
    createProfile: 'अपनी प्रोफ़ाइल बनाएं',
    browseSchemes: 'योजनाएं ब्राउज़ करें',
    checkEligibility: 'पात्रता जांचें',
  },

  // Profile Page
  profile: {
    title: 'आपकी प्रोफ़ाइल',
    createTitle: 'अपनी प्रोफ़ाइल बनाएं',
    updateTitle: 'अपनी प्रोफ़ाइल अपडेट करें',
    subtitle: 'व्यक्तिगत योजना सिफारिशें प्राप्त करने के लिए हमें अपने बारे में बताएं',
    personalInfo: 'व्यक्तिगत जानकारी',
    age: 'आयु',
    gender: 'लिंग',
    male: 'पुरुष',
    female: 'महिला',
    other: 'अन्य',
    caste: 'जाति श्रेणी',
    general: 'सामान्य',
    obc: 'ओबीसी',
    sc: 'एससी',
    st: 'एसटी',
    occupation: 'व्यवसाय',
    farmer: 'किसान',
    laborer: 'मजदूर',
    selfEmployed: 'स्व-रोजगार',
    salaried: 'वेतनभोगी',
    student: 'छात्र',
    unemployed: 'बेरोजगार',
    incomeRange: 'वार्षिक आय सीमा',
    below1lakh: '₹1 लाख से कम',
    '1to3lakh': '₹1-3 लाख',
    '3to5lakh': '₹3-5 लाख',
    '5to10lakh': '₹5-10 लाख',
    above10lakh: '₹10 लाख से अधिक',
    locationInfo: 'स्थान की जानकारी',
    state: 'राज्य',
    district: 'जिला',
    pincode: 'पिनकोड',
    saveProfile: 'प्रोफ़ाइल सहेजें',
    updateProfile: 'प्रोफ़ाइल अपडेट करें',
    profileSaved: 'प्रोफ़ाइल सफलतापूर्वक सहेजी गई!',
    profileUpdated: 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!',
  },

  // Schemes Page
  schemes: {
    title: 'सरकारी योजनाएं',
    subtitle: 'उन योजनाओं की खोज करें जिनके लिए आप पात्र हैं',
    searchPlaceholder: 'योजनाएं खोजें...',
    filters: 'फ़िल्टर',
    category: 'श्रेणी',
    level: 'स्तर',
    central: 'केंद्रीय',
    state: 'राज्य',
    allCategories: 'सभी श्रेणियां',
    agriculture: 'कृषि',
    education: 'शिक्षा',
    health: 'स्वास्थ्य',
    housing: 'आवास',
    employment: 'रोजगार',
    socialWelfare: 'सामाजिक कल्याण',
    viewDetails: 'विवरण देखें',
    applyNow: 'अभी आवेदन करें',
    eligibility: 'पात्रता',
    estimatedBenefit: 'अनुमानित लाभ',
    match: 'मिलान',
    basedOnProfile: 'आपकी प्रोफ़ाइल के आधार पर',
    noSchemes: 'कोई योजना नहीं मिली',
    createProfileFirst: 'व्यक्तिगत सिफारिशें देखने के लिए अपनी प्रोफ़ाइल बनाएं',
    loading: 'योजनाएं लोड हो रही हैं...',
    interestedQuestion: 'क्या आप इस योजना में रुचि रखते हैं?',
    interestedMessage: 'क्या आप लाभों का उपयोग कैसे करें इस पर व्यक्तिगत वित्तीय सलाह प्राप्त करने के लिए इस योजना को सहेजना चाहेंगे?',
    yesInterested: 'हां, मुझे रुचि है',
    noThanks: 'नहीं, धन्यवाद',
    saving: 'सहेजा जा रहा है...',
    noSchemesFound: 'कोई योजना नहीं मिली',
    noSchemesFilters: 'आपके वर्तमान फ़िल्टर से कोई योजना मेल नहीं खाती। अपनी खोज या फ़िल्टर समायोजित करने का प्रयास करें।',
    noSchemesAvailable: 'इस समय कोई योजना उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।',
    clearFilters: 'फ़िल्टर साफ़ करें',
  },

  // Scheme Detail Dialog
  schemeDetail: {
    description: 'विवरण',
    officialWebsite: 'आधिकारिक वेबसाइट',
    helpline: 'हेल्पलाइन',
    close: 'बंद करें',
    visitWebsite: 'आधिकारिक वेबसाइट पर जाएं',
    callHelpline: 'हेल्पलाइन पर कॉल करें',
  },

  // Applications Page
  applications: {
    title: 'मेरे आवेदन',
    subtitle: 'अपने योजना आवेदनों को ट्रैक करें',
    noApplications: 'अभी तक कोई आवेदन नहीं',
    startApplying: 'उन्हें यहां ट्रैक करने के लिए योजनाओं के लिए आवेदन करना शुरू करें',
    status: 'स्थिति',
    submittedOn: 'जमा किया गया',
    referenceNumber: 'संदर्भ संख्या',
    viewTimeline: 'समयरेखा देखें',
  },

  // Fraud Check Page
  fraudCheck: {
    title: 'धोखाधड़ी का पता लगाना',
    subtitle: 'जांचें कि कोई संदेश या कॉल घोटाला है या नहीं',
    inputLabel: 'संदेश दर्ज करें या कॉल का वर्णन करें',
    inputPlaceholder: 'संदेश पेस्ट करें या बताएं कि कॉलर ने क्या कहा...',
    checkButton: 'धोखाधड़ी की जांच करें',
    checking: 'विश्लेषण हो रहा है...',
    result: 'विश्लेषण परिणाम',
    safe: 'सुरक्षित',
    risky: 'जोखिम भरा',
    safeMessage: 'यह वैध प्रतीत होता है',
    riskyMessage: 'यह एक संभावित घोटाला प्रतीत होता है',
    explanation: 'स्पष्टीकरण',
  },

  // Education/Learn Finance Page
  education: {
    title: 'वित्त सीखें',
    subtitle: 'अपनी रुचि वाली योजनाओं पर व्यक्तिगत वित्तीय सलाह प्राप्त करें और लाभों का सर्वोत्तम उपयोग कैसे करें यह सीखें',
    overallPlan: 'समग्र वित्तीय योजना',
    overallPlanDesc: 'सभी से लाभों को प्रबंधित और उपयोग करने के बारे में व्यापक सलाह प्राप्त करें',
    schemesCount: 'योजनाएं एक साथ',
    getOverallAdvice: 'समग्र सलाह प्राप्त करें',
    yourSchemes: 'आपकी रुचि वाली योजनाएं',
    getAdvice: 'इन योजनाओं से लाभों का सर्वोत्तम उपयोग कैसे करें, इस पर व्यक्तिगत वित्तीय सलाह प्राप्त करें',
    noSchemes: 'अभी तक कोई रुचि वाली योजना नहीं',
    noSchemesDesc: 'योजनाओं को ब्राउज़ करें और व्यक्तिगत वित्तीय सलाह प्राप्त करने के लिए उन्हें रुचि के रूप में चिह्नित करें',
    getFinancialAdvice: 'वित्तीय सलाह प्राप्त करें',
    financialAdvice: 'वित्तीय सलाह',
    overallAdviceTitle: 'समग्र वित्तीय योजना',
    comprehensiveAdvice: 'के लिए व्यापक वित्तीय सलाह',
    combinedAnalysis: 'आपकी सभी रुचि वाली योजनाओं का संयुक्त विश्लेषण',
    generatingAdvice: 'व्यक्तिगत वित्तीय सलाह तैयार की जा रही है...',
    generatingPlan: 'व्यापक वित्तीय योजना तैयार की जा रही है...',
    overallAdviceLabel: 'समग्र सलाह',
    keyPoints: 'मुख्य बिंदु',
    utilizationTips: 'लाभों का उपयोग कैसे करें',
    potentialImpact: 'संभावित प्रभाव',
    removeScheme: 'योजना हटाएं',
  },

  // Common
  common: {
    retry: 'पुनः प्रयास करें',
    loading: 'लोड हो रहा है...',
    error: 'त्रुटि',
    success: 'सफलता',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    save: 'सहेजें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    back: 'वापस',
    next: 'अगला',
    submit: 'जमा करें',
    search: 'खोजें',
    filter: 'फ़िल्टर',
    clear: 'साफ़ करें',
    apply: 'लागू करें',
    close: 'बंद करें',
  },
};
